import React from 'react';

const ProgressBar = (props) => {
  const { bgColor, fgColor, status, message } = props;

  const fillerStyles = {
    display: 'flex'
  };

  const labelStyles = {
    height: '100%',
    width: `${status}%`,
    backgroundColor: `${bgColor}`,
    borderRadius: '10px',
    color: `${fgColor}`,
    fontSize: '14px',
    fontWeight: 'bold',
    padding: '2px',
    textAlign: 'center'
  };

  return (
      <div style={fillerStyles}>
        <span style={labelStyles}>
         {message}
        </span>
      </div>
  );
}
export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/SimpleProcessBar.js